import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    class: "login-form",
    id: "login-form"
};
const _hoisted_2 = { class: "login-form__title" };
const _hoisted_3 = {
    key: 0,
    class: "alert alert--error"
};
const _hoisted_4 = { class: "form__field-set" };
const _hoisted_5 = { class: "form__group form__group--required" };
const _hoisted_6 = { class: "form__label-wrapper" };
const _hoisted_7 = {
    for: "username",
    class: "form__label"
};
const _hoisted_8 = { class: "form__control-wrapper" };
const _hoisted_9 = { class: "form__group form__group--required form__group--password" };
const _hoisted_10 = { class: "form__label-wrapper" };
const _hoisted_11 = {
    for: "password",
    class: "form__label"
};
const _hoisted_12 = { class: "form__control-wrapper" };
const _hoisted_13 = { class: "form__buttons" };
const _hoisted_14 = {
    key: 0,
    type: "submit",
    class: "button button--primary",
    tabindex: "4",
    id: "login-submit-button"
};
const _hoisted_15 = {
    key: 1,
    class: "button button--primary button--disabled",
    id: "login-submit-loading"
};
import { onMounted, ref } from 'vue';
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import paloma from '@astina/paloma-common-ui/src/services/PalomaBackend';
import env from '../services/AppEnv';
import TermsAndConditionsAdditional from "../components/TermsAndConditionsAdditional.vue";
import TermsAndConditions from "../components/TermsAndConditions.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'LoginFormView',
    setup(__props) {
        const route = useRoute();
        const { te } = useI18n();
        const submitted = ref(false);
        const termsAccepted = ref(false);
        const loading = ref(false);
        const error = ref(false);
        const credentials = ref({
            username: '',
            password: '',
            remember: false,
        });
        onMounted(() => {
            // @ts-ignore
            credentials.value.username = route.query.user || route.query.username || '';
            // if no translation is defined for 'terms.accept', the checkbox + text are not shown
            termsAccepted.value = !te('terms.accept');
        });
        function authenticate() {
            submitted.value = true;
            if (!termsAccepted.value) {
                return;
            }
            loading.value = true;
            error.value = false;
            const data = new FormData();
            data.append('_username', credentials.value.username);
            data.append('_password', credentials.value.password);
            data.append('_remember', credentials.value.remember ? '1' : '0');
            paloma.http
                .post('security/auth', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
                .then(() => {
                const base = document.querySelector('head base');
                window.location.href = (base && base.getAttribute('href')) || (env.path + '/app/');
            })
                .catch(() => {
                submitted.value = true;
                error.value = true;
                loading.value = false;
            });
            // keep 'loading' for page reload on auth success
            // .finally(() => loading.value = false);
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_icon = _resolveComponent("icon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('login.title')), 1),
                _cache[13] || (_cache[13] = _createTextVNode()),
                _createElementVNode("form", {
                    onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event) => (authenticate()), ["prevent"])),
                    class: "form form--simple"
                }, [
                    (error.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('login.authorization-failed')), 1))
                        : _createCommentVNode("", true),
                    _cache[9] || (_cache[9] = _createTextVNode()),
                    _createElementVNode("fieldset", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('login.username')), 1)
                            ]),
                            _cache[4] || (_cache[4] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_8, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((credentials.value.username) = $event)),
                                    name: "_username",
                                    id: "username",
                                    class: "form__control",
                                    tabindex: "1",
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, credentials.value.username]
                                ])
                            ])
                        ]),
                        _cache[7] || (_cache[7] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('login.password')), 1),
                                _cache[5] || (_cache[5] = _createTextVNode()),
                                _createVNode(_component_router_link, {
                                    to: { name: 'login_reset_password' },
                                    class: "login-form__forgot-password"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('login.password-forgot')), 1)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _cache[6] || (_cache[6] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_12, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "password",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((credentials.value.password) = $event)),
                                    name: "_password",
                                    id: "password",
                                    class: "form__control",
                                    tabindex: "2",
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, credentials.value.password]
                                ])
                            ])
                        ])
                    ]),
                    _cache[10] || (_cache[10] = _createTextVNode()),
                    _createVNode(TermsAndConditions, {
                        modelValue: termsAccepted.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((termsAccepted).value = $event)),
                        submitted: submitted.value
                    }, null, 8, ["modelValue", "submitted"]),
                    _cache[11] || (_cache[11] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_13, [
                        (!loading.value)
                            ? (_openBlock(), _createElementBlock("button", _hoisted_14, [
                                _createVNode(_component_icon, { name: "login" }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('login.log-in')), 1)
                            ]))
                            : _createCommentVNode("", true),
                        _cache[8] || (_cache[8] = _createTextVNode()),
                        (loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createVNode(_component_icon, {
                                    name: "spinner",
                                    spin: true
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('login.please-wait')), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _cache[12] || (_cache[12] = _createTextVNode()),
                    _createVNode(TermsAndConditionsAdditional)
                ], 32)
            ]));
        };
    }
});
